import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import WebLogin from '../../components/login/WebLogin';
import AppLogin from '../../components/login/AppLogin';

export default function LoginPage() {
  const { user } = useAuth();
  const [isApp, setIsApp] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('platform') === 'app') {
      setIsApp(true);
    }
    // Or detect with userAgent if needed:
    // if (navigator.userAgent.includes('CantrysaApp')) setIsApp(true);
  }, []);

  return (
    <>
      {isApp ? <AppLogin /> : <WebLogin />}
    </>
  );
}